const QQ_APPID = {
  PROD: '101897657',
  TEST: '101890083',
};
const WX_APPID = 'wxf340e1c2d489e11a';

const LOGIN_MIDDLE_PAGE_URI = {
  QQ: 'https://h5.flow.qq.com/middlepages/qc_callback.html', // qq 互联
  WX: 'https://h5.flow.qq.com/middlepages/wx_callback.html',
  QQ_UNION: 'https://h5.flow.qq.com/middlepages/qq_union_cb.html', // qq 统一登录中间页（支持端内/端外）
};

const LOGIN_STATUS_KEYS = {
  NICK_NAME: 'nickName',
  OPENID: 'openid',
  TOKEN: 'token',
  ACCOUNT_TYPE: 'accountType',
};

// 环境类型
export const enum ENV_TYPE {
  MSDK = '1', // 游戏端内
  THIRD_LOGIN = '2', // 端外已登录场景
  GUEST = '3', // 端外未登录场景
}

export const enum LOGIN_TYPE {
  WX = 1,
  QQ = 2,
  NONE = 0,
}

export const ACCOUNT_TYPE = {
  [LOGIN_TYPE.WX]: '微信',
  [LOGIN_TYPE.QQ]: 'QQ',
};

export { QQ_APPID, WX_APPID, LOGIN_MIDDLE_PAGE_URI, LOGIN_STATUS_KEYS };
